export class Panel2OperativoI{
  totalFuentes : number;
  numReproceso : number;
  porcenReproceso : number;
  numAprobado : number;
  porcenAprobado : number;
  numCargado : number;
  porcenCargado : number;
  numEncargue : number;
  porcenEncargue : number;
  numEnproceso : number;
  porcenEnproceso : number;
  numPendientes : number;
  porcenPendiente : number;
}
